import type { SelfReport } from './api'

/**
 * The journal summary `/state` shows beside a reading (R72): the person's own
 * sleep, stress and caffeine answers in the prototype's units ("8 h",
 * "3 / 10", "1 cup"), and their note. An absent answer is `missing` — never a
 * sample value — and no check-in at all is null.
 */
export interface StateJournal {
  sleep: string
  /** The stress answer, `n / 10`. */
  level: string
  caffeine: string
  note: string | null
}

export function stateJournal(report: SelfReport | null | undefined, missing: string): StateJournal | null {
  if (report == null) return null
  const sleep = report.sleep_hours
  const level = report.stress_1_10
  const cups = report.caffeine_cups
  const note = typeof report.notes === 'string' && report.notes.trim() !== '' ? report.notes.trim() : null
  return {
    sleep: sleep == null ? missing : `${sleep} h`,
    level: level == null ? missing : `${level} / 10`,
    caffeine: cups == null ? missing : `${cups} ${cups === 1 ? 'cup' : 'cups'}`,
    note,
  }
}
